module.exports = __webpack_public_path__ + "img/end_btn.6eb00829.png";